import React from "react";

const Sitemap = () => {
  const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
  <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
    <url><loc>https://www.frankotrading.com/</loc></url>
    <url><loc>https://www.frankotrading.com/cart</loc></url>
    <url><loc>https://www.frankotrading.com/checkout</loc></url>
    <url><loc>https://www.frankotrading.com/products</loc></url>
    <url><loc>https://www.frankotrading.com/about</loc></url>
    <url><loc>https://www.frankotrading.com/contact</loc></url>
    <url><loc>https://www.frankotrading.com/order-history</loc></url>
    <url><loc>https://www.frankotrading.com/sign-in</loc></url>
    <url><loc>https://www.frankotrading.com/sign-up</loc></url>
  </urlset>`;

  return (
    <pre style={{ display: "none" }}>{sitemapContent}</pre>
  );
};

export default Sitemap;
